import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled("div")(props => ({
    ...theme(props).typography.primary.css(),
}));

export const Row = styled("div")({
    marginBottom: 12,
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
    width: 550,
});

export const Caption = styled("div")({
    flex: "0 1 100px",
});

export const Value = styled("div")({
    flex: "0 1 440px",
});
